<template>
  <div>
    <page-title :heading="heading" :subheading="subheading" :icon="icon"></page-title>
    <v-flex class="text-center" v-if="Sloading">
      <v-progress-circular color="primary" indeterminate size="50" />
    </v-flex>
    <div v-if="(items.length === 0 || items.length > 2) && !Sloading">
      <v-container text-xs-center>
        <h2>{{ $t('generalSearch.noResults') }}</h2>
      </v-container>
    </div>
    <!-- Encabezado -->
    <div v-if="items.length === 1 && !Sloading">
      <v-container grid-list-md text-xs-left>
        <v-layout row wrap class="ma-0 pa-0" v-for="item in items" :key="item.id">
          <v-flex xs4>
            <v-layout row align-center>
              <v-flex xs6>
                <span
                  class="font-weight-bold text-right"
                  style="color: primary; font-size: 17px"
                >
                  {{ $t('generalSearch.check') }}:
                </span>
              </v-flex>
              <v-flex xs3 class="text-left">
                <span class="pa-0">{{ item.id }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-layout row align-center>
              <v-flex xs3>
                <span
                  class="font-weight-bold text-right"
                  style="color: primary; font-size: 17px"
                >
                  {{ $t('general.status') }}:
                </span>
              </v-flex>
              <v-flex xs3 class="text-left">
                <span class="pa-0">{{ formStatus }}</span>
                <v-tooltip v-if="item.expenses_progress.length > 0 && viewExpenseReject(item.expenses_progress)" top>
                    <template v-slot:activator="{ on }">
                      <v-icon style="vertical-align: middle" class="error--text" size="18" v-on="on">mdi-flag</v-icon>
                    </template>
                    <span>{{viewExpenseRejectMessage(item.expenses_progress)}}</span>
                  </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-layout row align-center>
              <v-flex xs8>
                <span class="font-weight-bold text-right" style="color: primary; font-size: 17px">
                  {{ $t('generalSearch.checkType') }}:
                </span>
              </v-flex>
              <v-flex xs3>
                <span class="pa-0" >{{ getTypeText(item) }} </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-layout row align-center>
              <v-flex xs3>
                <span
                  class="font-weight-bold text-right"
                  style="color: primary; font-size: 17px"
                >
                  {{ $t('general.user') }}:
                </span>
              </v-flex>
              <v-flex xs6>
                <span class="pa-0">{{ item.user.name }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-layout row align-center>
              <v-flex xs3>
                <span class="font-weight-bold text-right" style="color: primary; font-size: 17px">
                  {{ $t('general.project') }}:
                </span>
              </v-flex>
              <v-flex xs3>
                <span class="pa-0">{{ item.project.name }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex v-if="item.petty_cash_type > 0" xs4 class="grey lighten-2" align-self-center>
            <v-layout row align-center>
              <v-flex>
                <span class="font-weight-bold text-right" style="font-size: 15px">
                  <v-icon left color="primary">paid</v-icon>
                  {{  item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }} :
                </span>
              </v-flex>
              <v-flex xs4 class="text-left">
                <span class="pa-0">
                  {{ item.user.small_box && item.user.small_box.amount | formatCurrency }} {{ tagMoneda }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-container>
      <!-- Tabla principal -->
      <v-container>
        <v-data-table :headers="headers" class="elevation-3" :items="items" hide-actions>
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :style="header.hidden ? 'display: none;' : ''"
                @click="changeSort(header.value)"
              >
                <h2 class="font-weight-bold primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable"
                    >arrow_upward</v-icon
                  >
                  {{ header.text }}
                </h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr style="border-bottom: none">
              <td class="text-xs-center">{{ props.item.description }}</td>
              <td class="text-xs-center">{{ props.item.project.name }}</td>
              <td class="text-xs-center">{{ props.item.start_date }}</td>
              <td class="text-xs-center">{{ props.item.end_date }}</td>
              <td class="text-xs-center">
                {{ props.item.advance | formatCurrency }}
              </td>
              <td v-if="props.item.total_items.length !== 0" class="text-xs-center">
                {{ getTotalAmount(props.item) | formatCurrency }}
              </td>
              <td
                class="text-xs-center"
                v-if="props.item.total_items.length === 0"
              >
                $0.00
              </td>
              <td class="text-xs-center">
                {{ props.item.gst_expenses_items.length }}
              </td>
              <td class="text-xs-center">
                {{ props.item.actions }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      outline
                      color="info"
                      v-on="on"
                      @click="getHistory(props.item)"
                    >
                      <v-icon small>history</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.history') }}</span>
                </v-tooltip>
              </td>
            </tr>
            <tr v-if="props.item.gst_expenses_items.length !== 0">
              <td colspan="11">
                <v-card flat>
                  <v-layout>
                    <v-flex xs12>
                      <span class="ml-3" style="font-size: 15px"><strong>{{ $t('general.expenseItems') }}</strong></span>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <table width="100%" class="my-3">
                        <thead>
                          <th class="text-sm-center font-weight-black">No.</th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.description') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.subtotal') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.total') }} {{ tagMoneda }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.comment') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.actions') }}
                          </th>
                        </thead>
                        <tbody v-for="item of props.item.gst_expenses_items" :key="item.id">
                          <tr v-if="item.has_multiprojects && item.isTitle" style="background-color: lightblue; height: 30px">
                            <td colspan="7"><b>{{item.titleName}}</b></td>
                          </tr>
                          <tr :class="selectionColor(item)" :style="{ backgroundColor: item.warning_restriction ? '#FFCC66' : '' }">
                            <td class="text-sm-center">
                              <!-- <div v-if="item.warning_restriction">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      style="vertical-align: middle"
                                      class="warning--text"
                                      size="18"
                                      v-on="on"
                                    >
                                      mdi-alert-octagram
                                    </v-icon>
                                  </template>
                                  {{ item.warning_restriction }}
                                </v-tooltip>
                              </div> -->
                              <span>{{ item.id }}</span>
                            </td>
                            <td width="450px" class="text-sm-center">
                              {{ item.description }}
                            </td>
                            <td class="text-sm-center">
                              {{ item.subtotal | formatCurrency }} ({{ item.currency.c_Moneda }})
                            </td>
                            <td class="text-sm-center">
                              {{ getTotalAmountByExpense(item) | formatCurrency }}
                            </td>
                            <td class="text-sm-center">{{ item.comment }}</td>
                            <td class="text-sm-center" v-if="item.gst_receipt_types_id !== 4">
                              <v-tooltip bottom  v-if="item.file_attach.length > 0">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    dark
                                    color="deep-purple darken-2"
                                    v-on="on"
                                    @click="attachFiles(item)"
                                  >
                                    <v-icon small>attach_file</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('expenses.attachedFiles') }}</span>
                              </v-tooltip>
                              <v-btn icon dark color="transparent" v-show="item.file_attach.length === 0">
                                <v-icon small></v-icon>
                              </v-btn>
                                <v-tooltip bottom v-if="item.receipt_type.id === 2 || item.receipt_type.id === 3">
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      dark
                                      color="teal"
                                      v-on="on"
                                      @click="viewItems(item)"
                                    >
                                      <v-icon small>remove_red_eye</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t('general.seeMore') }}</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="item !== null && item.receipt_type.id !== 2 && item.receipt_type.id !== 3">
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      dark
                                      color="teal"
                                      v-on="on"
                                      @click="viewItemsF(item)"
                                    >
                                      <v-icon small>remove_red_eye</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t('general.seeMore') }}</span>
                                </v-tooltip>
                            </td>
                            <!-- TD DE AJUSTE -->
                            <td v-else></td>
                          </tr>
                          <tr :style="{ backgroundColor: item.warning_restriction ? '#FFCC85' : '' }" v-if="item.warning_restriction">
                            <td :colspan="6" class="warning-text" style="padding: 1px;">
                              <v-icon style="vertical-align: middle" class="warning--text" size="18">mdi-alert-octagram</v-icon>
                              <span v-html="renderText(item.warning_restriction)"></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-card>
              </td>
            </tr>
          </template>
        </v-data-table>
        <!-- Botones de descarga -->
        <v-container v-for="item in items" :key="item.id">
          <v-layout justify-end>
            <v-flex class="text-xs-center" xs3 v-if="item.gst_travel_expenses_request_id">
              <v-btn
                round
                color="primary"
                dark
                :loading="loadingDownload"
                @click="downloadRequest(item)"
              >
                {{ $t('generalSearch.request') }}
                <v-icon right>mdi-file-pdf-box</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-center" xs3 v-if="item.gst_expenses_items.length !== 0">
              <v-btn
                round
                color="primary"
                dark
                :loading="loadingAccuse"
                @click="downloadAccuse(item)"
              >
                {{ $t('expenses.downloadAccuse') }}
                <v-icon right>mdi-file-pdf-box</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-center" xs3 v-if="item.gst_expenses_items.length !== 0">
              <v-btn
                round
                color="primary"
                dark
                :loading="loadingFilesZip"
                @click="downloadFilesZip(item)"
              >
                {{$t('general.downloadFiles')}}
                <v-icon right>get_app</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-center" xs3>
              <v-btn
                round
                color="primary"
                dark
                :loading="loadingExcelReport === item.id"
                @click="downloadExcelReport(item)"
              >
                {{ $t('general.expenseReport') }}
                <v-icon right>mdi-file-excel</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
      <!-- Modal de historial -->
      <v-dialog persistent v-model="histDialog" max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.tracking') }}
            </h2>
          </v-toolbar>
          <v-card-text v-if="histLoading">
            <v-layout>
              <v-flex class="text-center">
                <v-progress-circular color="primary" indeterminate size="50" />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text v-if="!histLoading">
            <v-layout wrap>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('workflowValidation.expenseNo') }}:
                  </span>
                  {{ histItem.id }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.workflow') }}:
                  </span>
                  {{ workflowName }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.description') }}:
                  </span>
                  {{ histItem.description }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.project') }}:
                  </span>
                  {{ histItem.project.name }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.startDate') }}:
                  </span>
                  {{ histItem.start_date }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.endDate') }}:
                  </span>
                  {{ histItem.end_date }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-divider />
                <h3 class="primary--text font-weight-black">
                  {{ $t('expenses.progress') }}:
                </h3>
                <v-card flat color="grey lighten-3">
                  <v-layout>
                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.sented.length > 0
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="histSteps.sented.length > 0 ? 'white' : 'grey'"
                      >
                        <v-icon
                          v-if="histSteps.sented.length > 0"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >1</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.sented')
                      }}</span>
                    </v-flex>
                    <v-divider vertical />
                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.reviewed.length > 0
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="
                          histSteps.reviewed.length > 0 ? 'white' : 'grey'
                        "
                      >
                        <v-icon
                          v-if="histSteps.reviewed.length > 0"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >2</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.reviewed')
                      }}</span>
                    </v-flex>
                    <v-divider vertical />
                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.payable.length
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="histSteps.payable.length ? 'white' : 'grey'"
                      >
                        <v-icon
                          v-if="histSteps.payable.length"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >3</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.approved')
                      }}</span>
                    </v-flex>
                    <v-divider vertical />
                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.paid.length
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="histSteps.paid.length ? 'white' : 'grey'"
                      >
                        <v-icon
                          v-if="histSteps.paid.length"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >4</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.paid')
                      }}</span>
                    </v-flex>
                  </v-layout>
                  <v-divider class="my-0 primary" />
                  <v-layout>
                    <v-flex v-if="histSteps.sented.length > 0" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.sented') }}:
                      </h3>
                      <li class="text-sm-left">
                        {{ histSteps.sented[0].user.name + ' - ' + histSteps.sented[0].created_at }}
                      </li>
                      <h3 v-if="histSteps.sented[0].user.name !== representExpense.name" class="primary--text font-weight-black">
                        {{ $t('expenses.history.inRepresentationOf') }}:
                      </h3>
                      <li v-if="histSteps.sented[0].user.name !== representExpense.name" class="text-sm-left">
                        {{ representExpense.name }}
                      </li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex v-if="histSteps.reviewed.length > 0" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.reviewed') }}:
                      </h3>
                      <li v-for="step of histSteps.reviewed" :key="step.id" class="text-sm-left">
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                      <v-flex v-if="validatorsExpenses !== null && isApproved === false">
                        <h3 v-if="pendingValidatorsC.length > 0" class="grey--text font-weight-black py-2">
                          {{ $t('expenses.history.pending') }}
                        </h3>
                        <ul v-for="validator of pendingValidatorsC" :key="validator.validator.user_id" class="text-sm-left">
                          <h6 class="text-center font-weight-black">
                            {{ $t('validator.name') }} {{ validator.validatorId }}
                          </h6>
                          {{ validator.validator.user.name }}
                          <h6 v-if="validator.substitutes !== null" class="text-center grey--text pt-1" >
                            {{ $t('general.substitutes') }}
                          </h6>
                          <li v-if="validator.substitutes !== null" class="text-sm-left grey--text">
                            {{ validator.substitutes.user.name }}
                          </li>
                        </ul>
                        <v-spacer></v-spacer>
                      </v-flex>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3
                        class="grey--text font-weight-black py-2"
                        v-if="validators.length > 0"
                      >
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="validator of validators" :key="validator.id">
                        <h6 class="text-center font-weight-black">
                          {{ $t('validator.name') }} {{ validator.validatorId }}
                        </h6>
                        <li class="text-sm-left grey--text">
                          {{ validator.validator.user.name }}
                        </li>
                        <h6
                          v-if="validator.substitutes !== null"
                          class="text-center grey--text pt-1"
                        >
                          {{ $t('general.substitutes') }}
                        </h6>
                        <li
                          v-if="validator.substitutes !== null"
                          class="text-sm-left grey--text"
                        >
                          {{ validator.substitutes.user.name }}
                        </li>
                        <v-spacer></v-spacer>
                      </ul>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex
                      v-if="histSteps.payable.length > 0"
                      class="text-center pa-3"
                      xs4
                    >
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.payable') }}:
                      </h3>
                      <li
                        class="text-sm-left"
                        v-for="step of histSteps.payable"
                        :key="step.id"
                      >
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="approver of approvers" :key="approver.id">
                        <li class="text-sm-left grey--text">
                          {{ approver.users[0].name }}
                        </li>
                      </ul>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex
                      v-if="histSteps.paid.length > 0"
                      class="text-center pa-3"
                      xs4
                    >
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.paid') }}:
                      </h3>
                      <li
                        class="text-sm-left"
                        v-for="step of histSteps.paid"
                        :key="step.id"
                      >
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="approver of approvers" :key="approver.id">
                        <li class="text-sm-left grey--text">
                          <!-- {{ approver.users[0].name }} -->
                            <!-- ÚNICO CASO ARLETTE -->
                          {{ ($store.state.userLogged && $store.state.userLogged.company && $store.state.userLogged.company[0] && ($store.state.userLogged.company[0].id === 49 || $store.state.userLogged.company[0].id === 50)) ? 'BARAJAS PEREZ ARLETTE DANIELA' : approver.users[0].name }}
                        </li>
                      </ul>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal para "Ver mas" -->
      <v-dialog v-model="dialogF" scrollable max-width="900px" persistent>
        <v-card v-if="receipt_type === 1">
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.item') }}{{ editedItem.id }}
              <span>
                (
                {{
                  editedItem.receipt_type ? editedItem.receipt_type.name : ''
                }}
                )</span
              >
            </h2>
            <v-spacer />
            <v-btn v-if="applyFeatures && editedItem.gst_receipt_types_id === 1" round flat color="primary" @click="showEditCategoryF">
              <v-icon left>list</v-icon> {{ titleTagCategory }}
            </v-btn>
            <v-btn
              :disabled="!cfdiHtml"
              round
              flat
              color="primary"
              @click="sendToPrint()"
              ><v-icon left>print</v-icon> {{ $t('general.print') }}</v-btn
            >
            <v-flex class="text-right">
              <v-btn :disabled="!showPrevious" small icon outline color="primary" @click="viewPrevious(editedItem.id)" class="mx-5">
                  <v-icon small>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn :disabled="!showNext" small icon outline color="primary" @click="viewNext(editedItem.id)" class="mx-5">
                  <v-icon small>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn small icon color="error" @click="close" class="ml-5">
                <v-icon small>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-toolbar>
          <v-card-text v-if="!editCategoryF">
            <iframe
              name="cfdi"
              :srcdoc="cfdiHtml"
              style="width: 845px; height: 1200px; border: 0"
            >
            </iframe>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form lazy-validation ref="formf" v-model="validF">
                  <v-flex xs12 md6>
                    <v-select
                      disabled
                      required
                      :items="categories"
                      item-value="id"
                      item-text="name"
                      class="mr-3"
                      :label="$t('categories.name')"
                      v-model="editedItem.gst_categories_id"
                    >
                    </v-select>
                  </v-flex>
                </v-form>
                <v-flex xs12>
                  <v-textarea
                    :label="$t('general.comment')"
                    disabled
                    outline
                    v-model="editedItem.comment"
                  >
                  </v-textarea>
                </v-flex>
                <h2 class="font-weight-black primary--text mb-0 flex xs12">
                  {{ formTitleTip }}
                </h2>
                <v-form
                  v-if="editedItemTip.created_at !== ''"
                  ref="tipForm"
                  lazy-validation
                >
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItemTip.amount"
                          :label="$t('general.amount')"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex v-if="dataURL">
                        <v-flex xs12>
                          <label>{{ $t('expenses.file') }}:</label>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                          <v-btn
                            block
                            v-if="isPDF(dataURL)"
                            @click="openPDF()"
                            color="primary"
                            depressed
                          >
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                          <iframe
                            v-if="isPDF(dataURL)"
                            :src="dataURL"
                            frameborder="0"
                            width="100%"
                            height="400px"
                          ></iframe>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-text v-if="editCategoryF">
            <v-layout>
              <v-flex md12>
                <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                <v-layout>
                  <v-data-table
                      style="width: 100%;"
                      :headers="conceptsHeader"
                      :items="conceptos"
                      loading-text="Cargando contenido"
                      no-data-text="No hay datos que mostrar"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <tr>
                            <td class="text-sm-left text-truncate" style="width: 40%">
                              <v-text-field
                                auto-grow
                                outlined
                                dense
                                :hide-details="true"
                                color="primary"
                                v-model="props.item.line"
                                :disabled="true"
                              />
                              </td>
                              <td style="width: 20%">
                              <v-text-field
                                outlined
                                dense
                                :hide-details="true"
                                color="primary"
                                v-model="props.item.amount"
                                :disabled="true"
                              />
                              </td>
                              <td style="width: 30%" class="text-sm-center">
                                <v-autocomplete class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]" :items="categories"  color="primary"/>
                              </td>
                              <td style="width: 10%">
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <v-btn :disabled="true" @click="editConceptsCategory(props.item, props.index)" small icon outline color="primary" v-on="on">
                                  <v-icon small>edit</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.edit') }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close"
            >
              {{ $t('general.close') }}
            </v-btn>
            <v-spacer />
            <div v-if="editedItem.receipt_type">
              <v-btn
                color="success darken-1"
                round
                flat
                v-if="editedItem.receipt_type.id == 1"
                :loading="loadingXML"
                @click="downloadXML('itemF')"
              >
                {{ $t('general.downloadXML') }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.item') }}{{ editedItem.id }}
              <span>
                (
                {{
                  editedItem.receipt_type ? editedItem.receipt_type.name : ''
                }}
                )</span
              >
            </h2>
            <v-btn class="marginLeft" v-if="editedItem.gst_receipt_types_id === 3 && applyFeatures" round flat color="primary" @click="showEditCategory">
              <v-icon left>list</v-icon> {{ titleTagCategory }}
            </v-btn>
            <v-flex class="text-right">
              <v-btn
                :disabled="!showPrevious"
                small
                icon
                outline
                color="yellow"
                @click="viewPrevious(editedItem.id)"
                class="mx-5"
              >
                <v-icon small>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                :disabled="!showNext"
                small
                icon
                outline
                color="blue"
                @click="viewNext(editedItem.id)"
                class="mx-5"
              >
                <v-icon small>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn small icon color="error" @click="close" class="ml-5">
                <v-icon small>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-toolbar>
          <v-card-text v-if="!editCategory">
            <v-form lazy-validation ref="form" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                    <v-flex xs12>
                          <v-text-field
                            :label="$t('general.date')"
                            v-model="editedItem.date"
                            disabled
                            prepend-icon="event"
                          >
                          </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.country')"
                            disabled
                            prepend-icon="location_on"
                            v-model="editedItem.country.descripcion"
                          >
                          </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 v-if="editedItem.gst_category_id !== null">
                      <v-select
                        disabled
                        required
                        :items="categories"
                        item-value="id"
                        item-text="name"
                        class="mr-3"
                        :label="$t('categories.name')"
                        prepend-icon="list"
                        v-model="editedItem.gst_category_id"
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex v-if="items && hasMultiProjects" xs12 md12>
                      <v-autocomplete v-model="editedItem.project_id" :label="$t('general.project')" prepend-icon="list" :items="items[0].multiprojects" item-value="id" item-text="name" disabled></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.description')"
                        disabled
                        prepend-icon="forum"
                        v-model="editedItem.description"
                      >
                      </v-textarea>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.currency')"
                        disabled
                        prepend-icon="paid"
                        v-model="editedItem.currency.descripcion"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.exchangeRate')"
                        disabled
                        prepend-icon="currency_exchange"
                        v-model="editedItem.exchange"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                      <v-text-field
                        :label="$t('general.supplier')"
                        disabled
                        prepend-icon="store"
                        v-model="editedItem.vendor.name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.subtotal')"
                        disabled
                        prepend-icon="attach_money"
                        v-model="editedItem.subtotal"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.total') + ' (' + tagMoneda + ')'"
                        disabled
                        prepend-icon="attach_money"
                        v-model="editedItem.total"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex  xs12 md6>
                      <v-text-field v-if="editedItem.sat_forma_pago != null" :label="$t('general.formaPago')" disabled prepend-icon="credit_card" v-model="editedItem.sat_forma_pago.descripcion">
                      </v-text-field>
                      <v-text-field v-else :label="$t('general.formaPago')" disabled prepend-icon="credit_card"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.folioRef')"
                        disabled
                        prepend-icon="article"
                        v-model="editedItem.folio"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.comment')"
                        disabled
                        prepend-icon="3p"
                        v-model="editedItem.comment"
                      >
                      </v-textarea>
                    </v-flex>
                    </v-flex>
                  <v-flex xs6 layout v-if="dataURL">
                    <v-flex xs12>
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                      <iframe
                            v-if="isPDF(dataURL)"
                            :src="dataURL"
                            frameborder="0"
                            width="100%"
                            height="400px"
                          ></iframe>
                      <v-btn
                        block
                        v-if="isPDF(dataURL)"
                        @click="openPDF()"
                        color="primary"
                        depressed
                      >
                        <v-icon left>insert_drive_file</v-icon>
                        {{ $t('expenseItems.watchFile') }}
                      </v-btn>
                    </v-flex>
                  </v-flex>
                  <h2 class="font-weight-black primary--text mb-0 flex xs12">
                    {{ formTitleTip }}
                  </h2>
                  <v-form
                    v-if="editedItemTip.created_at !== ''"
                    ref="tipForm"
                    lazy-validation
                  >
                    <v-container>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="editedItemTip.amount"
                            :label="$t('general.amount')"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 layout v-if="dataURL">
                          <v-flex xs12>
                            <label>{{ $t('expenses.file') }}:</label>
                            <a v-if="!isPDF(dataURL)" @click="openPDF()">
                              <zoom-on-hover
                                :img-normal="dataURL"
                              ></zoom-on-hover>
                            </a>
                            <v-btn
                              block
                              v-if="isPDF(dataURL)"
                              @click="openPDF()"
                              color="primary"
                              depressed
                            >
                              <v-icon left>insert_drive_file</v-icon>
                              {{ $t('expenseItems.watchFile') }}
                            </v-btn>
                            <iframe
                              v-if="isPDF(dataURL)"
                              :src="dataURL"
                              frameborder="0"
                              width="100%"
                              height="400px"
                            ></iframe>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text v-if="editCategory">
            <v-layout>
              <v-flex md12>
                <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                <v-layout>
                    <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="concepts"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-sm-left text-truncate" style="width: 40%">
                            <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                          </td>
                          <td style="width: 20%">
                            <v-text-field class="text-sm-center" @input="getTotal(3)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" type="number" :disabled="true"/>
                          </td>
                          <td style="width: 30%" class="text-sm-center">
                            <v-autocomplete  class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]" :items="categories"  color="primary" />
                          </td>
                          <td style="width: 10%">
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <v-btn :disabled="true" @click="editConceptsCategory(props.item, props.index)" small icon outline color="primary" v-on="on">
                                  <v-icon small>edit</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.edit') }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close"
            >
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogApprobedF"
        scrollable
        max-width="900px"
        persistent>
          <v-card v-if="receipt_type === 1">
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ editedItemApprobedF.id }} <span> ( {{editedItemApprobedF.gst_receipt_types ? editedItemApprobedF.gst_receipt_types.name : ''}} )</span></h2>
              <v-spacer/>
              <v-btn
                :disabled="!cfdiHtml"
                round
                flat
                color="primary"
                @click="sendToPrint()">
                <v-icon left>print</v-icon> {{$t('general.print')}}
              </v-btn>
              <v-flex class="text-right">
                <v-btn
                  small
                  icon
                  color="error"
                  @click="close"
                  class="ml-5">
                  <v-icon small>clear</v-icon>
                </v-btn>
              </v-flex>
            </v-toolbar>
            <v-card-text>
              <iframe
                name="cfdi"
                :srcdoc="cfdiHtml"
                style="width:845px; height:1100px; border:0">
              </iframe>
              <v-form
                lazy-validation
                ref="approvedFiscalForm"
                v-model="approvedFiscalValid">
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 md6>
                          <v-select
                            required
                            :items="categories"
                            item-value="id"
                            item-text="name"
                            class="mr-3"
                            :label="$t('categories.name')"
                            v-model="editedItemApprobedF.gst_categories_id">
                          <template slot="selection" slot-scope="data">
                              {{ data.item.name}}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{data.item.name}}
                            </template>
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.comment')"
                            disabled
                            outline
                            v-model="editedItemApprobedF.comment">
                          </v-textarea>
                        </v-flex>
                        <h2 class="font-weight-black primary--text mb-0 flex xs12">{{formTitleTip}}</h2>
                        <v-form v-if="editedItemTip.created_at !== ''"
                          ref="tipForm"
                          lazy-validation>
                          <v-container>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-text-field
                                  v-model="editedItemTip.amount"
                                  :label="$t('general.amount')"
                                  >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 layout v-if="dataURL">
                                <v-flex xs12>
                                  <label>{{$t('expenses.file')}}:</label>
                                  <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                    <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                                  </a>
                                  <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                                    <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                                  </v-btn>
                                  <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                                </v-flex>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-form>
                    </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary darken-1"
                flat
                round
                class="white--text"
                depressed
                @click="close">
                {{$t('general.close')}}
              </v-btn>
              <v-spacer />
                <v-btn
                  color="success darken-1"
                  round
                  flat
                  :loading="loadingXML"
                  @click="downloadXML('itemApproved')"
                >
                  {{ $t('general.downloadXML') }}
                </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-else>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ itemsApprobedView.id }} <span> ( {{itemsApprobedView.gst_receipt_types ? itemsApprobedView.gst_receipt_types.name : ''}} )</span></h2>
              <v-flex class="text-right">
              <v-btn
                :disabled="!showPrevious"
                small
                icon
                outline
                color="green"
                @click="viewPrevious(itemsApprobedView.id)"
                class="mx-5"
              >
                <v-icon small>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                :disabled="!showNext"
                small
                icon
                outline
                color="red"
                @click="viewNext(itemsApprobedView.id)"
                class="mx-5"
              >
                <v-icon small>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn small icon color="error" @click="close" class="ml-5">
                <v-icon small>clear</v-icon>
              </v-btn>
            </v-flex>
            </v-toolbar>
            <v-card-text>
              <v-form
                lazy-validation
                ref="approvedNoFiscalForm"
                v-model="approvedNoFiscalValid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex layout row wrap v-bind:class="{'xs6': dataURL}">
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.date')"
                            disabled
                            outline
                            v-model="itemsApprobedView.date">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            required
                            :items="categories"
                            item-value="id"
                            item-text="name"
                            class="mr-3"
                            :label="$t('categories.name')"
                            v-model="itemsApprobedView.gst_categories_id">
                          <template slot="selection" slot-scope="data">
                              {{ data.item.name}}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{data.item.name}}
                            </template>
                          </v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.country')"
                            disabled
                            outline
                            v-model="itemsApprobedView.country.descripcion">
                          </v-text-field>
                        </v-flex>
                        <v-flex v-if="items && hasMultiProjects" xs12 md12>
                          <v-autocomplete v-model="itemsApprobedView.project_id" :label="$t('general.project')" prepend-icon="list" :items="items[0].multiprojects" item-value="id" item-text="name" disabled></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.description')"
                            disabled
                            outline
                            v-model="itemsApprobedView.description">
                          </v-textarea>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.currency')"
                            disabled
                            outline
                            v-model="itemsApprobedView.currency.descripcion">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.exchangeRate')"
                            disabled
                            outline
                            v-model="itemsApprobedView.exchange">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.subtotal')"
                            disabled
                            outline
                            v-model="itemsApprobedView.subtotal">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.total') + ' (' + tagMoneda + ')'"
                            disabled
                            outline
                            v-model="itemsApprobedView.total">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.formaPago')"
                            disabled
                            outline
                            v-model="itemsApprobedView.sat_forma_pago.descripcion">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.folioRef')"
                            disabled
                            outline
                            v-model="itemsApprobedView.folio">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.comment')"
                            disabled
                            outline
                            v-model="itemsApprobedView.comment">
                          </v-textarea>
                        </v-flex>
                    </v-flex>
                    <v-flex xs6 layout v-if="dataURL">
                      <v-flex xs12>
                        <a v-if="!isPDF(dataURL)" @click="openPDF()">
                          <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                        </a>
                        <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                          <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                        </v-btn>
                      </v-flex>
                    </v-flex>
                    <h2 class="font-weight-black primary--text mb-0 flex xs12">{{formTitleTip}}</h2>
                    <v-form v-if="editedItemTip.created_at !== ''"
                      ref="tipForm"
                      lazy-validation>
                      <v-container>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="editedItemTip.amount"
                              :label="$t('general.amount')"
                              >
                            </v-text-field>
                          </v-flex>
                            <v-flex xs12 layout v-if="dataURL">
                            <v-flex xs12>
                              <label>{{$t('expenses.file')}}:</label>
                              <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                              </a>
                              <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                                <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                              </v-btn>
                              <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary darken-1"
                flat
                round
                class="white--text"
                depressed
                @click="close">
                {{$t('general.close')}}
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'generalSearchComponent',
  data() {
    return {
      editItemCategories: {},
      titleTagCategory: this.$t('general.category'),
      editCategory: false,
      editCategoryF: false,
      concepts:[],
      conceptos: [],
      settings: {},
      currencySetting: {},
      tagMoneda: '',
      approvedFiscalValid: true,
      showPrevious: true,
      showNext: true,
      loadingExcelReport: false,
      approvedNoFiscalValid: true,
      loadingAccuse: false,
      loadingFilesZip: false,
      expand: true,
      Sloading: true,
      workflowName: '',
      loadingXML: false,
      isApproved: false,
      loadingDownload: false,
      items: [],
      approvers: [],
      validators: [],
      categories: [],
      validatorsExpenses: [],
      pendingValidators: [],
      histDialog: false,
      dialogApprobedF: false,
      loading: false,
      valid: true,
      validF: true,
      dataURL: null,
      cfdiHtml: null,
      receipt_type: '',
      dialogF: false,
      histLoading: false,
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      editedItem: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: 'name',
        },
        sat_metodo_pago: {},
        validator_comment: '',
        item_lines: [],
        project_id: ''
      },
      itemsApprobedView: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        gst_receipt_types: {
          name: '',
        },
        validator_comment: '',
        project_id: ''
      },
      histItem: {
        id: 1,
        description: 'alguna vaina',
        start_date: '',
        end_date: '',
        project: {
          name: '',
        },
        progress: [],
        steps: [
          {
            status: 1,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
              {
                id: 2,
                name: 'fulano',
              },
            ],
          },
          {
            status: 2,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
            ],
          },
        ],
      },
      userLogged: {
        roles: [
          {
            id: null,
          },
        ],
        company: [
          {
            id: null,
          },
        ],
      },
      histSteps: {
        sented: [],
        reviewed: [],
        payable: [],
        paid: [],
      },
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        pageCount: 0,
        totalItems: 0,
      },
      editedItemApprobedF: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        gst_receipt_types: {
          name: '',
        },
        sat_metodo_pago: {},
        validator_comment: '',
        project_id: ''
      },
      creatorExpense: {},
      representExpense: {},
      expenses: {}
    }
  },
  mounted() {
    this.getState()
  },
  computed: {
    hasMultiProjects(){
      if(this.$store.state.userLogged && this.$store.state.userLogged.company[0].features.find(x => x.name === 'MULTIPROJECTS')) return true
      
      return false
    },
    pendingValidatorsC() {
    if(!this.validators) return []

      let pendingValidatorsA = this.validators
      this.histItem.progress.forEach((item) => {
        pendingValidatorsA = pendingValidatorsA.filter(
          (x) => x.validator.user_id !== item.user_id
        )
      })
      return pendingValidatorsA
    },
    applyFeatures(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'EXPENSE_LINES')){
        return true
      }

      return false
    },
    formTitleTip() {
      if (this.editedItemTip.created_at !== '') {
        return this.$t('expenses.tip')
      } else {
        return ''
      }
    },
    formStatus() {
      const status = this.items[0].status_expense.id
      if (status === 1) {
        return this.$t('expenses.exs.created')
      } else if (status === 2) {
        return this.$t('expenses.exs.sented')
      } else if (status === 3) {
        return this.$t('expenses.exs.reviewed')
      } else if (status === 4) {
        return this.$t('expenses.exs.payable')
      } else if (status === 5) {
        return this.$t('expenses.exs.payment')
      } else if (status === 6) {
        return this.$t('expenses.exs.paid')
      }
    },
    conceptsHeader() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false
        }
      ]
    },
    headers() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project',
          sortable: false,
        },
        {
          text: this.$t('general.startDate'),
          align: 'center',
          value: 'startDate',
          sortable: false,
        },
        {
          text: this.$t('general.endDate'),
          align: 'center',
          value: 'endDate',
          sortable: false,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: false,
        },
        {
          text: `${this.$t('general.totalAmount')} ${this.tagMoneda}`,
          align: 'center',
          value: 'total',
          sortable: false,
        },
        {
          text: this.$t('general.expenseItems'),
          align: 'center',
          value: 'expense',
          sortable: false,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ]
    },
    heading() {
      return this.$t('generalSearch.name')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fas fa-search fa-fw icon-color'
    },
  },
  watch: {
    settings(){
      this.filterCurrency()
    },
    '$store.state.search'() {
      this.getState()
    },
    '$store.state.type'() {
      this.getState()
    },
  },
  methods: {
    getTotalAmount(item) {
      return Number(item.total_items[0].sumtotal_mxn) + Number(item.total_amount_tip)
    },
    getTotalAmountByExpense(item) {
      return Number(item.subtotal) * Number(item.exchange)
    },
    titleProject(item, project_id){
      return item.multiprojects.find(x => x.id === project_id).name
    },
    resetCategories(){
      this.editCategory = false
      this.editCategoryF = false
      this.titleTagCategory = this.$t('general.category')
      this.editItemCategories = {}
    },
    showEditCategory(){
      this.concepts = JSON.parse(JSON.stringify(this.editedItem.item_lines))
      this.concepts.forEach(item => { item.editCategory = false });
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory ? this.$t('general.category') : this.$t('general.expense') 
    },
    showEditCategoryF(){
      this.conceptos = JSON.parse(JSON.stringify(this.editedItem.item_lines))
      this.conceptos.forEach(item => { item.editCategoryF = false });
      this.editCategoryF = !this.editCategoryF
      this.titleTagCategory = !this.editCategoryF ? this.$t('general.category') : this.$t('general.expense') 
    },
    /**
     * Método para descargar archivo de excel
     */
     filterCurrency() {
    const foundCurrencySetting = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
    this.currencySetting = foundCurrencySetting ? foundCurrencySetting : { value: { c_Moneda: 'MXN' } }
    this.tagMoneda = this.currencySetting.value.c_Moneda
    this.editedItem.currency = this.currencySetting.value
    // this.defaultItem.currency = this.currencySetting.value
    },
    renderText(text) {
      return text.replace(/<br\s*\/?>/g, '<br>');
    },
    downloadExcelReport({ id }) {
      this.$emit('downloadExcelReport', {
        context: this,
        id,
      })
    },
    selectionColor(item) {
      let color = ''
      
      if (item.gst_receipt_types_id === 4){
        return 'custom-row-color'
      }

      if (item.uuid === this.$store.state.search) {
        color = 'grey lighten-2'
        return color
      }
      
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    close() {
      this.approvers = []
      this.histDialog = false
      this.dialogF = false
      this.dialogApprobedF = false
      this.resetCategories()
    },
    getHistory(item) {
      this.histLoading = true // cambiar a true
      this.histDialog = true
      this.histItem = item
      this.histItem.progress = []
      this.$emit('getHistory', { id: item.id, context: this })
      this.$emit('getWorkflowValidatorApprover', {
        user_id: item.user_id,
        context: this,
      })
      this.$emit('getExpensesValidators', { id: item.id, context: this })
    },
    filterHistory() {
      if (this.histItem.progress.length > 0) {
        this.histSteps.sented = this.histItem.progress.filter(
          (item) => item.status === 'Enviado'
        )
        this.histSteps.reviewed = this.histItem.progress.filter(
          (item) => item.status === 'Revisado'
        )
        this.histSteps.payable = this.histItem.progress.filter(
          (item) => item.status === 'Aprobado'
        )
        this.histSteps.paid = this.histItem.progress.filter(
          (item) => item.status === 'Pagado'
        )
        if (this.histSteps.payable.length > 0) {
          this.isApproved = true
        }
      }
    },
    attachFiles(item) {
      this.$router.push('/expenses/files/watch/' + item.id)
    },
    viewItems(items) {
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 2
      this.addTip(items)
      this.editedItem = Object.assign({}, items)
      const total = this.getTotalAmountByExpense(items)
      this.editedItem.total = parseFloat(total.toFixed(2))
      this.editedItem.gst_category_id = this.editedItem.gst_categories
        ? this.editedItem.gst_categories.id
        : null
      this.dialogF = true
      this.loading = false
      this.disabled = false
      items.views = true
      if (items.gst_receipt_types_id === 2 || items.gst_receipt_types_id === 3) {
        if (
          items.gst_expenses_items_files !== undefined &&
          items.gst_expenses_items_files !== null
        ) {
          if (items.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: items.gst_expenses_items_files[0].files_id,
              },
            })
          }
        }
      }
    },
    viewItemsF(items) {
      const taxID = this.$store.state.userLogged.company[0].tax_id
      if (
        taxID === 'ING1811295P0' &&
        items.sat_formaPago_id !== null &&
        items.uuid === null
      ) {
        if (!items.gst_receipt_types) {
          items.gst_receipt_types = {
            name: 'fiscal',
          }
        }
        this.viewItemsApprobed(items)
        return
      }
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 1
      this.addTip(items)
      if (items.gst_expenses_items_files.length > 0) {
        this.editedItem = items
        this.$emit('readXmlToHtml', {
          id: items.gst_expenses_items_files[0].files_id,
          context: this,
          type: 'viewItemsF',
        })
      }
      items.views = true
    },
    viewItemsApprobedF(itemsF) {
      const taxID = this.$store.state.userLogged.company[0].tax_id
      if (
        taxID === 'ING1811295P0' &&
        itemsF.sat_formaPago_id !== null &&
        itemsF.uuid === null
      ) {
        itemsF.isFiscal = true
        this.viewItemsApprobed(itemsF)
        return
      }

      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 1
      this.addTip(itemsF)
      if (itemsF.gst_expenses_items_files.length > 0) {
        this.editedItemApprobedF = itemsF
        this.$emit('readXmlToHtml', {
          id: itemsF.gst_expenses_items_files[0].files_id,
          context: this,
          type: 'viewItemsApprobedF',
        })
        itemsF.views = true
      }
    },
    viewNext(id) {
      this.resetCategories()
      let index = this.items[0].gst_expenses_items.findIndex((x) => x.id === id)
      if (index <= this.items[0].gst_expenses_items.length - 2) {
        if (this.items[0].gst_expenses_items[index + 1].gst_receipt_types_id === 1) {
          this.viewItemsF(this.items[0].gst_expenses_items[index + 1])
        } else {
          this.viewItems(this.items[0].gst_expenses_items[index + 1])
        }
      } else {
        if (this.items[0].gst_expenses_items[0].gst_receipt_types_id === 1) {
          this.viewItemsF(this.items[0].gst_expenses_items[0])
        } else {
          this.viewItems(this.items[0].gst_expenses_items[0])
        }
      }
    },
    viewPrevious(id) {
      this.resetCategories()
      let index = this.items[0].gst_expenses_items.findIndex((x) => x.id === id)
      if (index !== 0) {
        if (this.items[0].gst_expenses_items[index - 1].gst_receipt_types_id === 1) {
          this.viewItemsF(this.items[0].gst_expenses_items[index - 1])
        } else {
          this.viewItems(this.items[0].gst_expenses_items[index - 1])
        }
      } else {
        if (
          this.items[0].gst_expenses_items[this.items[0].gst_expenses_items.length - 1]
            .gst_receipt_types_id === 1
        ) {
          this.viewItemsF(this.items[0].gst_expenses_items[this.items[0].gst_expenses_items.length - 1])
        } else {
          this.viewItems(this.items[0].gst_expenses_items[this.items[0].gst_expenses_items.length - 1])
        }
      }
    },
    addTip(item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
    },
    getTip(item) {
      this.$emit('getTip', {
        context: this,
        id: item.id,
      })
    },
    viewItemsApprobed(itemsApprobed) {
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 2
      this.addTip(itemsApprobed)
      this.itemsApprobedView = Object.assign({}, itemsApprobed)
      this.dialogApprobedF = true
      this.loading = false
      this.disabled = false
      itemsApprobed.views = true
      const taxID = this.$store.state.userLogged.company[0].tax_id

      if (itemsApprobed.gst_receipt_types_id === 2) {
        if (
          itemsApprobed.gst_expenses_items_files !== undefined &&
          itemsApprobed.gst_expenses_items_files !== null
        ) {
          if (itemsApprobed.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: itemsApprobed.gst_expenses_items_files[0].files_id,
              },
            })
          }
        }
      } else if(taxID === 'ING1811295P0' && 
              itemsApprobed.gst_receipt_types_id === 1 && 
              itemsApprobed.gst_categories.name === 'Caseta' || 
              itemsApprobed.gst_categories.name ===  'Gasolina') {
          if (
            itemsApprobed.gst_expenses_items_files !== undefined &&
            itemsApprobed.gst_expenses_items_files !== null
          ) {
            if (itemsApprobed.gst_expenses_items_files.length > 0) {
              this.$store.dispatch('getFile', {
                event: {
                  context: this,
                  fileId: itemsApprobed.gst_expenses_items_files[0].files_id,
                },
              })
            }
          }
      }
    },
    getState() {
      this.Sloading = true
      this.$emit('get', {
        context: this,
        id: this.$store.state.search,
        select: this.$store.state.type,
      })
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    downloadRequest(item) {
      this.loadingDownload = true
      this.$emit('downloadRequest', {
        context: this,
        item: item.gst_travel_expenses_request_id,
      })
    },
    downloadAccuse(item) {
      this.loadingAccuse = true
      this.$emit('downloadAccuse', {
        id: item.id,
        context: this,
      })
    },
    downloadFilesZip(item) {
      this.loadingFilesZip = true
      if (item.user_id) {
        this.$emit('downloadFilesZip', {
          item: {
            id: item.id,
            user_id: item.user_id,
            start_date: item.start_date,
            end_date: item.end_date
          },
          context: this,
        })
      }
    },
    downloadXML(type) {
      this.loadingXML = true
      if (type === 'itemApproved') {
        this.$store.dispatch('downloadXML', {
          event: {
            context: this,
            fileId:
              this.editedItemApprobedF.gst_expenses_items_files[0].files_id,
            description: this.editedItemApprobedF.description,
          },
        })
      } else {
        this.$store.dispatch('downloadXML', {
          event: {
            context: this,
            fileId: this.editedItem.gst_expenses_items_files[0].files_id,
            description: this.editedItem.description,
          },
        })
      }
    },
    getType(item) {
      if (item.is_imported_expense === 1) return 'travelExpense'
      if (item.petty_cash_type === 0 && item.is_blue_voucher) return 'voucher_blue' 
      if (item.petty_cash_type === 1) return 'petty_cash'
      if (item.petty_cash_type === 2) return 'amex_card'
      if (parseFloat(item.advance) > 0) return 'advance'
      if (parseFloat(item.advance) <= 0 && item.petty_cash_type === 0) return 'refund'
    },
    getTypeText(item) {
      switch (this.getType(item)) {
        case 'travelExpense': return this.$t('expenses.travelExpense.title') 
        case 'advance': return this.$t('general.advance')
        case 'refund': return this.$t('general.refund')
        case 'petty_cash': {
          const pettyCashLabel = this.$t('pettyCash.pettyCash');
          const blueVoucherLabel = item.is_blue_voucher === 1 ? ` ${this.$t('general.with')} ${this.$t('general.okBlue')}` : '';
          return pettyCashLabel + blueVoucherLabel;
        }
        case 'amex_card': 
          const pettyCashLabel = this.$t('pettyCash.amexCard');
          const blueVoucherLabel = item.is_blue_voucher === 1 ? ` ${this.$t('general.with')} ${this.$t('general.okBlue')}` : '';
          return pettyCashLabel + blueVoucherLabel;
        case 'voucher_blue': return this.$t('general.okBlue')
        default: return ''
      }
    },
    viewExpenseReject(expenses_progress){
      return expenses_progress.some(expense => expense.status === "Regresado")
    },
    viewExpenseRejectMessage(expenses_progress){
      const expenseProgress =  expenses_progress
        .filter(expense => expense.status === "Regresado")
        .reduce((prev, current) => (prev.id > current.id) ? prev : current)

      return `${this.$t('general.commentFrom')} ${expenseProgress.user.name} "${expenseProgress.comment}"`
    }
  },
}
</script>

<style scoped>
.hist-steps {
  background-color: #63b225 !important;
}
.custom-row-color {
    background-color:rgba(137, 119, 240, 0.322); /* Cambia el color a tu preferencia */
}
</style>



// WEBPACK FOOTER //
// src/components/generalSearch.component.vue